<template lang="pug">
.report-views
  nav(ref="reportNav")
    .categories
      //- label 全部标签
      .category
        .type
          .label(
            v-for="(c, i) in types",
            :key="i",
            @click.prevent="checked_type = c"
          )
            span(:class="{ active: c === checked_type }") {{ c }}
  section
    article
      ReportViewsList(:lists="lists")
      .loading(v-if="pages.now < pages.sum")
        span(@click.prevent="loadingMore") 查看更多
      .loading(v-if="loading")
        loader
    //- aside
    //-   p.label 时间
    //-   .times(
    //-     v-for="(t, i) in times",
    //-     :key="i",
    //-     :class="{ active: t.name === time }",
    //-     @click.prevent="time = t.name"
    //-   ) {{ t.name }}
</template>

<script>
import client from '../server/server'
import DataNull from '../components/DataNull'
import Loader from '../components/Loader'
import ReportViewsList from './ReportViewsList.vue'
export default {
  name: 'ReportViews',
  components: {
    Loader,
    DataNull,
    ReportViewsList
  },
  data () {
    return {
      times: [],
      time: '',
      checked_type: '全部',
      types: [],
      lists: [],
      pages: {
        now: 1,
        sum: 1
      },
      loading: false,
      qrcodeUrl: require('../assets/img/index/qrcode.png')
    }
  },
  mounted () {
    this.getCondition()
  },
  watch: {
    time () {
      this.pages.now = 1
      this.getList()
    },
    checked_type () {
      this.pages.now = 1
      this.getList()
    }
  },
  methods: {
    getCondition () {
      client.getReportsCondition()
        .then(res => {
          if (res.success) {
            this.times = res.data.times
            this.time = this.times[0].name
            this.types = ['全部', ...res.data.types]
          }
        })
    },
    getList () {
      let params = {
        page: this.pages.now,
        size: 10,
        // startTime: this.times.find(d => d.name === this.time).startTime,
        // endTime: this.times.find(d => d.name === this.time).endTime,
        type: this.checked_type === '全部' ? null : this.checked_type
      }
      if (params.page === 1) {
        this.lists = []
      }
      this.loading = true
      client.getReports(params)
        .then(res => {
          if (res.success) {
            let tmp = res.data.list.map(d => {
              return Object.assign({}, d, {
                brands: d.priBrands.concat(d.secBrands)
              })
            })
            if (this.pages.now === 1) {
              this.lists = [...tmp]
            } else {
              this.lists = this.lists.concat(tmp)
            }
            this.pages.sum = res.data.pages
            this.loading = false
          }
        })
    },
    loadingMore () {
      this.pages.now++
      this.getList()
    },
    collect (id, boolean) {
      let data = {
        id: id,
        collect: boolean
      }
      client.changeReportCollect(data)
        .then(res => {
          if (res.success) {
            this.lists.find(d => d.id === id).hasCollect = boolean
          } else {
            return new Error(res.message)
          }
        })
    },
    defaultImg (e) {
      e.target.src = require('@index/assets/img/report_default.png')
    },
    buyReport () {
      let html = `
        <div style="text-align: center">
            <img src=${this.qrcodeUrl} style="width: 200px;height: 200px">
            <p>请联系客服购买报告</p>
        </div>
      `
      this.$alert(html, '', {
        dangerouslyUseHTMLString: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.report-views {
  flex: 1;

  nav {
    margin-top: 40px;
    padding: 24px 0 4px;
    background: #fff;
    border-radius: 4px;
    font-size: 12px;

    .times,
    .categories {
      display: flex;
      align-items: flex-start;

      label {
        min-width: 50px;
        margin-right: 20px;
        color: #999;
        margin-top: 6px;
      }

      .type {
        display: flex;
        flex-flow: row wrap;
      }

      div.label {
        min-width: 110px;
        text-align: center;
        margin-bottom: 20px;
      }

      span {
        display: inline-block;
        color: #666;
        padding: 6px 12px;
        border-radius: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background-color: #347eee;
        }
      }
    }
  }

  section {
    display: flex;
  }

  aside {
    min-width: 65px;
    margin-left: 20px;
    height: 100%;
    margin-top: 20px;
    font-size: 12px;
    color: #666;

    p.label {
      margin-bottom: 7px;
    }

    .times {
      margin-left: 12px;
      height: 28px;
      line-height: 28px;
      border-left: 1px solid #ccc;
      padding-left: 14px;
      position: relative;
      cursor: pointer;

      &.active {
        color: #3989cb;

        &::before {
          background-color: #3989cb;
        }
      }

      &::before {
        position: absolute;
        content: "";
        left: 0;
        top: 50%;
        transform: translate(-4px, -50%);
        width: 8px;
        height: 8px;
        background-color: #ccc;
        border-radius: 4px;
      }
    }
  }

  article {
    overflow-y: auto;
    margin-top: 20px;
    height: 100%;
    background: #fff;
    border-radius: 4px;
    position: relative;
    flex: 1;

    .loading {
      text-align: center;
      padding: 10px 0;
      color: #999;
      font-size: 12px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/ReportDownload/ReportViews.vue